/** @format */

import React from "react";

const Popup = ({ viewPupup, hidePupup, viewWidth, children }) => {
  return (
    <div className={viewPupup === true ? "style-pupup" : "style-pupup hide"}>
      <div className='overlay' onClick={hidePupup}></div>
      <div className={`content-pupup ${viewWidth}`}>{children}</div>
    </div>
  );
};

export default Popup;
